/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

// required attributes
const CheckCardBinR = t.interface({});

// optional attributes
const CheckCardBinO = t.partial({
  cardBin: t.string,

  urlLogo: t.string
});

export const CheckCardBin = t.intersection(
  [CheckCardBinR, CheckCardBinO],
  "CheckCardBin"
);

export type CheckCardBin = t.TypeOf<typeof CheckCardBin>;
